import UploadAttachmentsModal from './UploadAttachmentsModal'
import ViewAttachmentDrawer from './ViewAttachmentDrawer'

export { UploadAttachmentsModal, ViewAttachmentDrawer }

export const MODALS = {
  uploadAttachments: UploadAttachmentsModal,
  viewAttachment: ViewAttachmentDrawer
}
